import React from "react";
import Modal from "./Modal";
import { useForm, useFieldArray } from "react-hook-form";
import { useState, useEffect, useMemo } from "react";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerPerfilesParametros,
  eliminarParametro,
  actualizarPerfilParametro,
  AgregarPerfilParametro,
} from "../../redux/perfilSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import Required from "../../Components/Required";
import { OrderTable } from "../../Components/OrderTable";
import useSubmit from "../../Hooks/useSubmit";
import { getAdminParameterPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { _translateValue } from "../translation-gestor/translateValue";

import { useValidation } from "../../Hooks/useValidation";

const SCREEN_NAME = "PantallaPerfilesParametros";
function PerfilesParametros(props) {
  const { validation } = useValidation();
  const { locale } = useLocale();
  const [adminParameterPage, setAdminParameterPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedPerfiles, setTranslatedPerfiles] = useState({});
  const [translatedNivelesAcademicos, setTranslatedNivelesAcademicos] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);
  const [modalState, changeModalState] = useState(false);
  const [removeState, changeRemoveState] = useState(false);
  const [registerSelected = [], selectReg] = useState();
  const [tituloModal, setTituloModal] = useState("Agregar perfil");
  const [carreras, setCarreras] = useState([]);

  const { width } = WindowDimension();
  const dispatch = useDispatch();

  const { submitAction } = useSubmit();

  const { perfilesParametros } = useSelector((state) => state.perfiles);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    watch,
  } = useForm({
    defaultValues: {
      parametroId: 0,
      estudiaCostaRica: false,
      viveTrabajaCostaRica: false,
      nivelAcademicoId: undefined,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "carreras",
  });

  const nivelId = watch("nivelAcademicoId");

  const columns = useMemo(() => {
    const profileParamTable = adminParameterPage?.profileParam_table ?? [];
    return [
      { label: profileParamTable[0]?.label || 'Código', accessor: 'parametroId', sortable: true },
      { 
        label: profileParamTable[1]?.label || 'Perfil', 
        accessor: 'perfilNombre', 
        sortable: true,
        render: (item) => (
          <td>{translatedPerfiles[item.perfilNombre] || item.perfilNombre}</td>
        ),
      },
      {
        label: profileParamTable[2]?.label || 'Nivel académico',
        accessor: 'nivelAcademicoNombre',
        sortable: true,
        render: (item) => (
          <td>{translatedNivelesAcademicos[item.nivelAcademicoNombre] || item.nivelAcademicoNombre}</td>
        ),
      },
      {
        label: profileParamTable[3]?.label || 'Estudió en Costa Rica',
        accessor: 'estudiaCostaRica',
        sortable: false,
        render: (item) => (
          <td>
            {item.estudiaCostaRica ? (
              <i className="material-icons success"></i>
            ) : (
              <i className="material-icons danger"></i>
            )}
          </td>
        ),
      },
      {
        label: profileParamTable[4]?.label || 'Vive o trabaja en Costa Rica',
        accessor: 'viveTrabajaCostaRica',
        sortable: false,
        render: (item) => (
          <td>
            {item.viveTrabajaCostaRica ? (
              <i className="material-icons success"></i>
            ) : (
              <i className="material-icons danger"></i>
            )}
          </td>
        ),
      },
      {
        label: profileParamTable[5]?.label || 'Carreras',
        accessor: 'carreras',
        sortable: true,
        render: (item) => <td>{item.carreras.length}</td>,
      },
      { label: profileParamTable[6]?.label || 'Acción', accessor: 'action', sortable: false },
    ];
  }, [adminParameterPage, translatedPerfiles, translatedNivelesAcademicos]);

  useEffect(() => {}, [perfilesParametros]);

  useEffect(() => {
    cargarPerfiles();
  }, [dispatch]);

  const habdledCarreras = (getAll) => {
    if (getAll) {
      setCarreras(perfilesParametros?.carreras);
    } else {
      setCarreras(perfilesParametros?.carreras.filter((x) => x.estadoId == 4));
    }
  };

  const showModalEdit = (reg) => {
    reset(reg);
    setTituloModal(adminParameterPage?.subtitleTR || "Editar parámetro");
    changeModalState(true);
    habdledCarreras(true);

    selectReg(reg);
  };

  const closeModalEdit = () => {
    reset({
      parametroId: 0,
      estudiaCostaRica: false,
      viveTrabajaCostaRica: false,
      nivelAcademicoId: undefined,
    });
    changeModalState(false);
  };

  const showRemoveModalEdit = (reg) => {
    selectReg(reg);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    selectReg();
    changeRemoveState(false);
  };

  const cargarPerfiles = () => {
    dispatch(obtenerPerfilesParametros());
  };

  const eliminar = async () => {
    submitAction(eliminarParametro, registerSelected.parametroId, () => {
      closeRemoveModalEdit();
      cargarPerfiles();
    });
  };

  const actualizar = async (data) => {
    if (data.carreras) {
      data.carreras = data.carreras.map((a) => parseInt(a.carreraId));
    }

    submitAction(
      data.parametroId > 0 ? actualizarPerfilParametro : AgregarPerfilParametro,
      data,
      () => {
        closeModalEdit();
        cargarPerfiles();
      }
    );
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminParameterPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminParameterPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminParameterPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los campos "Perfil" y "Nivel académico" cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasPerfilesParametros = perfilesParametros?.perfilesParametros && Array.isArray(perfilesParametros.perfilesParametros) && perfilesParametros.perfilesParametros.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasPerfilesParametros) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const perfilTranslations = {};
      const nivelAcademicoTranslations = {};

      // Traducir solo los campos solicitados
      const translationPromises = perfilesParametros.perfilesParametros.map(async (item) => {
        if (item.perfilNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.perfilNombre, locale);
          perfilTranslations[item.perfilNombre] = translated;
        }
        if (item.nivelAcademicoNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.nivelAcademicoNombre, locale);
          nivelAcademicoTranslations[item.nivelAcademicoNombre] = translated;
        }
      });
      await Promise.all(translationPromises);

      // Actualizar estados y finalizar traducción
      setTranslatedPerfiles(perfilTranslations);
      setTranslatedNivelesAcademicos(nivelAcademicoTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [perfilesParametros?.perfilesParametros, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <div className="main-admin">
        <div className="main-admin-bar">
          <Skeleton.Button style={{ width: 40, height: 40 }} active />
          <Skeleton.Input style={{ width: 300, height: 30 }} active />
        </div>
        <div className="table-container">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
      </div>
    );
  }

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <button
          className="main-admin-button"
          onClick={() => {
            changeModalState(true);
            setTituloModal(adminParameterPage?.subtitle || "Nuevo parámetro");
            reset();
            habdledCarreras(false);
          }}
        >
          +
        </button>
        <h2>{adminParameterPage?.title || "Parámetros de perfiles"}</h2>
      </div>

      <div className="table-container">
        {perfilesParametros?.perfilesParametros?.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={perfilesParametros?.perfilesParametros}
              clase="table-adm"
              actions={[
                {
                  icon: "",
                  clase: "text-primary",
                  event: (item) => showModalEdit(item),
                },
                {
                  icon: "",
                  clase: "text-primary",
                  event: (item) => showRemoveModalEdit(item),
                },
              ]}
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={modalState}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "medium"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(actualizar)}
            >
              {adminParameterPage?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div className="params-container">
            <div className="params-form-container">
              <div className="form-group">
                <label>{adminParameterPage?.level_academy || "Nivel académico"}</label>
                <Required />
                <select
                  className="form-control"
                  {...register("nivelAcademicoId", {
                    required: validation?.required_field || "Campo requerido",
                  })}
                >
                  <option value="">{adminParameterPage?.select_option || "Seleccione"}</option>
                  {perfilesParametros?.nivelesAcademicos?.map((d, i) => (
                    <option key={d.nivelId} value={d.nivelId}>
                      {d.nivelAcademicoNombre}
                    </option>
                  ))}
                </select>
                {errors.nivelAcademicoId && (
                  <p className="error">{errors.nivelAcademicoId.message}</p>
                )}
              </div>

              <div className="d-flex align-self-center ">
                <input
                  {...register("estudiaCostaRica")}
                  type="checkbox"
                  className="form-control-check d-flex"
                />
                <label>{adminParameterPage?.whereStudy || "Estudia en Costa Rica"}</label>
              </div>
              <div className="d-flex align-self-center">
                <input
                  {...register("viveTrabajaCostaRica")}
                  type="checkbox"
                  className="form-control-check d-flex"
                />
                <label>{adminParameterPage?.whereWork || "Vive o trabaja en Costa Rica"}</label>
              </div>
            </div>

            <div className="form-group">
              <label>{adminParameterPage?.programApply || "Carreras en las que se aplica:"}</label>
              <Required />

              <div className="form-group">
                <div>
                  <button
                    type="button"
                    className="button-text"
                    onClick={() => {
                      append({
                        carreraId: undefined,
                      });
                    }}
                  >
                    {adminParameterPage?.addProgram || "Agregar carrera"}
                  </button>
                </div>
              </div>

              <ul>
                {fields.map((item, index) => {
                  return (
                    <li key={"el_" + index}>
                      <div className="form-group flex-form gap-20">
                        <select
                          className="form-control"
                          defaultValue={item.carreraId}
                          {...register(`carreras.${index}.carreraId`, {
                            required: validation?.required_field || "Campo requerido",
                          })}
                        >
                          <option value="">{adminParameterPage?.select_option || "Seleccione"}</option>
                          {carreras
                            .filter((x) => x.nivelId == nivelId)
                            ?.map((d, i) => (
                              <option key={d.carreraId} value={d.carreraId}>
                                {d.carreraNombre}
                              </option>
                            ))}
                        </select>

                        <button
                          type="button"
                          onClick={() => remove(index)}
                          className="modBtn"
                        >
                          <i className="material-icons"></i>
                        </button>
                      </div>
                      {errors.carreras?.[index]?.carreraId && (
                        <p className="error">
                          {errors.carreras?.[index]?.carreraId.message}
                        </p>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="form-group">
              <label>{adminParameterPage?.ProfileApply || "Perfil a aplicar"}</label>
              <Required />
              <select
                className="form-control"
                {...register("perfilId", { required: validation?.required_field || "Campo requerido" })}
              >
                <option value="">{adminParameterPage?.select_option || "Seleccione"}</option>
                {perfilesParametros?.perfiles?.map((d, i) => (
                  <option key={d.perfilId} value={d.perfilId}>
                    {d.perfilNombre}
                  </option>
                ))}
              </select>
              {errors.perfilId && (
                <p className="error">{errors.perfilId.message}</p>
              )}
            </div>
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={changeRemoveState}
        title={adminParameterPage?.subtitleT || "Eliminar parametro"}
        message={adminParameterPage?.description || "¿Seguro que desea eliminar el siguiente parametro?"}
        item={registerSelected.parametroId}
        icon={null}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              {adminParameterPage?.confirm_button || "Confirmar"}
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              {adminParameterPage?.cancel_button || "Cancelar"}
            </button>
          </>
        }
      />
    </div>
  );
}

export default PerfilesParametros;
